import { computed } from 'vue'
import { useCurrencyStore } from '@/stores/CurrencyStore'

export interface HomepagePhoneContact {
  region: 'US' | 'CA' | 'AU'
  number: string
  icon: string
}

const phoneContacts: HomepagePhoneContact[] = [
  {
    region: 'US',
    number: '+1 (877) 908 9878',
    icon: '/images/home/us-icon.svg'
  },
  {
    region: 'CA',
    number: '+1 (866) 886 3998',
    icon: '/images/home/ca-icon.svg'
  },
  {
    region: 'AU',
    number: '+61 (1800) 959 936',
    icon: '/images/home/au-icon.svg'
  }
]

const headerDropdownContacts = phoneContacts.slice(1)

// Service line for a display currency: AUD -> AU, CAD -> CA, everything else -> US.
export function getPhoneContactRegion(currencyCode: string): HomepagePhoneContact['region'] {
  const code = String(currencyCode || '').toUpperCase()
  if (code === 'AUD') return 'AU'
  if (code === 'CAD') return 'CA'
  return 'US'
}

export function useHomepagePhoneContacts() {
  const currencyStore = useCurrencyStore()
  // The single number shown in the header/menu, matching the selected currency.
  const currentContact = computed<HomepagePhoneContact>(
    () =>
      phoneContacts.find((c) => c.region === getPhoneContactRegion(currencyStore.currentCurrency)) ??
      phoneContacts[0]
  )
  return {
    phoneContacts,
    headerDropdownContacts,
    currentContact
  }
}
